import { CSS as TableCSS } from '../../components/table/table.style';
import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-FormList',
	loading: 'c-FormList--loading',
	tableCell: 'c-FormList__TableCell',
	tableCellButton: 'c-FormList__TableCellButton',
	tableCellFaint: 'c-FormList__TableCell--faint',
	tableCellMenu: 'c-FormList__TableCell--menu',
	archivedSection: 'c-FormList__ArchivedSection',
	archivedHeader: 'c-FormList__ArchivedHeader',
	archivedHeaderIcon: 'c-FormList__ArchivedHeaderIcon',
	archivedRow: 'c-FormList__ArchivedRow',
};

export const Style = {
	[CSS.container]: {
		[`& .${TableCSS.container}`]: {
			width: '80%',
			'margin-bottom': DefaultTheme.space(6),
		},
		[`& .${TableCSS.header} > th:last-of-type`]: {
			width: '100px',
		},
		[`& .${TableCSS.cell}:last-of-type`]: {
			overflow: 'visible',
		},
		[`& .${TableCSS.header} > th:nth-of-type(4), & .${TableCSS.header} > th:nth-of-type(5)`]: {
			width: '220px',
		},
	},
	[CSS.loading]: {
		display: 'flex',
		'justify-content': 'center',
		padding: DefaultTheme.space(4),
	},
	[CSS.tableCell]: {
		'text-overflow': 'ellipsis',
		overflow: 'hidden',
		'white-space': 'nowrap',
	},
	[CSS.tableCellButton]: {
		padding: `0 ${DefaultTheme.space(1)}`,
		'text-align': 'left',
	},
	[CSS.tableCellFaint]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.tableCellMenu]: {
		position: 'relative',
		display: 'flex',
		'justify-content': 'flex-end',
		overflow: 'visible',
	},
	[CSS.archivedSection]: {
		'margin-top': DefaultTheme.space(2),
	},
	[CSS.archivedHeader]: {
		display: 'flex',
		'align-items': 'center',
		cursor: 'pointer',
		padding: `${DefaultTheme.space(2)} 0`,
		'user-select': 'none',
		color: DefaultTheme.font.color.supporting,
		'font-size': '16px',
		'font-weight': '500',
	},
	[CSS.archivedHeaderIcon]: {
		'margin-right': DefaultTheme.space(1),
		transition: 'transform 0.2s ease',
	},
	[CSS.archivedRow]: {
		opacity: '0.5',
	},
};
